import { Component } from '@angular/core';
import { FieldBaseComponent } from '../field-base';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormFieldErrorComponent } from '../form-field-error/form-field-error.component';

@Component({
  selector: 'lib-form-textarea',
  templateUrl: './form-textarea.component.html',
  imports: [ReactiveFormsModule, FormsModule, FormFieldErrorComponent],
})
export class FormTextareaComponent extends FieldBaseComponent {}
